<div class="default-settings">
  <h2>Save Default Values?</h2>

  <div mat-dialog-content class="default-settings--height default-settings--overflow-hidden">
    <div class="default-weight-height u-font-weight-400 u-font-size-14 line-height-24">Would you like to store this athlete's <strong>Weight</strong>, and <strong>Height</strong> as default values?</div>
    <div class="default-weight-height u-font-weight-400 u-font-size-14 line-height-24 u-margin-bottom-10">This way, you won’t have to enter them again next time. You can still edit them later if needed.</div>

    <div class="o-flex o-flex--justify-space-between u-margin-bottom-15">
      <span class="u-font-weight-500 u-font-size-16">Athlete Measurements</span>
      <span class="u-font-weight-500 u-font-size-16">Default Settings</span>
    </div>
    <div *ngIf="data.isWeightChanged" class="o-flex o-flex--justify-space-between u-margin-bottom-20">
      <span class="u-font-weight-400 u-font-size-16 default-weight-height">Weight</span>
      <mat-radio-group class="o-flex default-settings--radio-group-gap" [(ngModel)]="weightDefault" aria-label="Select an option">
        <mat-radio-button color="primary" [value]="true">Yes</mat-radio-button>
        <mat-radio-button color="primary" [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div *ngIf="data.isHeightChanged" class="o-flex o-flex--justify-space-between">
      <span class="u-font-weight-400 u-font-size-16 default-weight-height">Height</span>
      <mat-radio-group class="o-flex default-settings--radio-group-gap" [(ngModel)]="heightDefault" aria-label="Select an option">
        <mat-radio-button color="primary" [value]="true">Yes</mat-radio-button>
        <mat-radio-button color="primary" [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <mat-dialog-actions align="center">
    <button class="width-49-percent" mat-raised-button (click)="onDismiss()">Not Now</button>
    <button class="width-49-percent" mat-raised-button color="primary" (click)="onConfirm()">Save</button>
  </mat-dialog-actions>
</div>
